import { useMemo } from 'react';
import { usePlugins } from '@/hooks/config/usePlugins';
import type { ResolvedNavItem } from '@/lib/plugin-registry';

/**
 * The plugin nav items pinned under every takeover aside: Send feedback plus
 * the off-site links (Documentation, Releases) that used to take rows in the
 * account dropdown.
 *
 * Shared by {@link TakeoverFeedbackFooter} and the mobile More sheet, because
 * the aside's footer is desktop-only — below `md` the sheet is where these
 * live. `to` is used verbatim: every contribution here is either a hash
 * command or `rootLevel`, so there is no org slug to apply.
 */
export function useTakeoverFooterItems(): ResolvedNavItem[] {
  const { navItems } = usePlugins();
  return useMemo(
    () =>
      navItems
        .filter((item) => item.group === 'takeover-footer')
        .sort((a, b) => (a.order ?? 0) - (b.order ?? 0)),
    [navItems],
  );
}
